import React from 'react';
import { PropTypes } from 'prop-types';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';
import { getTimelineAssignmentMessage } from 'common/Workqueue/timelineEventUtils';

const EnrollmentAssignmentEvent = ({ timelineEvent }) => {
  const date = formatDate(timelineEvent.timestamp);

  return (
    <BaseTimelineEvent
      icon="IconUserCircle"
      message={getTimelineAssignmentMessage(timelineEvent)}
      date={date}
    />
  );
};

EnrollmentAssignmentEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default EnrollmentAssignmentEvent;
